import { Box, Typography, ButtonProps } from '@mui/material';

import constants from './constants';
import AuthenticationPanelButton from './AuthenticationPanelButton';

function AuthenticationPanel({
    source,
    showButtonIcon = true,
    showCaption = true,
    buttonColor = 'primary',
    customImage = '',
    connectedContent = null,
    showConnectedConfirmation = true,
    disconnectButton = null,
    showOrganizationName = true,
}: {
    source: keyof typeof constants.oauthPresentation;
    showButtonIcon?: boolean;
    showCaption?: boolean;
    buttonColor?: ButtonProps['color'];
    customImage?: string;
    connectedContent?: React.ReactNode;
    showConnectedConfirmation?: boolean;
    disconnectButton?: React.ReactNode;
    showOrganizationName?: boolean;
}) {
    if (!constants.oauthPresentation[source]) {
        return null;
    }

    return (
        <Box
            aria-label={`${source} authentication panel`}
            sx={{
                flex: '1 1 0',
                width: 'auto',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    // Wraps only when the row runs out of room, so the button drops below the logo on
                    // a phone instead of pushing the panel wider than the screen.
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 2,
                }}>
                <Box
                    sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        gap: 2.5,
                    }}>
                    <img
                        height={constants.oauthPresentation[source]?.imageHeight}
                        alt={`${source} logo`}
                        src={customImage || constants.oauthPresentation[source]?.image}
                    />
                    {connectedContent}
                </Box>
                <AuthenticationPanelButton
                    source={source}
                    showButtonIcon={showButtonIcon}
                    buttonColor={buttonColor}
                    showConnectedConfirmation={showConnectedConfirmation}
                    disconnectButton={disconnectButton}
                    showOrganizationName={showOrganizationName}
                />
            </Box>
            {showCaption && (
                <Typography
                    sx={{
                        marginTop: 4,
                        display: 'block',
                    }}
                    variant="caption">
                    {constants.oauthPresentation[source]?.text}
                </Typography>
            )}
        </Box>
    );
}

export default AuthenticationPanel;
